import { BoBreadcrumb, boBreadcrumbConfig } from "back-office/shared/components/BoBreadcrumb"
import { LucideIcon } from "lucide-react"

interface GenericViewHeaderProps {
  /**
   * Titre à afficher
   */
  title: string;

  /**
   * Icône Lucide à afficher
   */
  icon: LucideIcon;

  /**
   * Libellé de section affiché en surtitre (ex. « Acteurs », « Activité »)
   */
  section?: string;

  /**
   * Afficher ou non le breadcrumb (désactivé par défaut sur les pages admin)
   * @default false
   */
  showBreadcrumb?: boolean;

  /**
   * Configuration personnalisée du breadcrumb
   */
  breadcrumbConfig?: typeof boBreadcrumbConfig;

  /**
   * Séparateur du breadcrumb
   * @default ">"
   */
  breadcrumbSeparator?: string;

  /**
   * Classes CSS supplémentaires pour le titre
   */
  titleClassName?: string;

  /**
   * Classes CSS supplémentaires pour l'icône
   */
  iconClassName?: string;
}

export const GenericViewHeader = ({
  title,
  icon: Icon,
  section,
  showBreadcrumb = false,
  breadcrumbConfig = boBreadcrumbConfig,
  breadcrumbSeparator = ">",
  titleClassName = "",
  iconClassName = ""
}: GenericViewHeaderProps) => {
  // Identité visuelle commune des pages admin : bandeau blanc pleine largeur
  // (les marges négatives compensent le padding de SimpleDashboardContent),
  // tuile d'icône + surtitre + titre fort, pour situer l'utilisateur en un coup d'œil.
  return (
    <div className="-mx-4 -mt-4 mb-8 border-b border-gray-200 bg-white px-8 py-8 shadow-sm md:-mx-16 md:-mt-16 md:px-20 md:py-10">
      <div className="flex items-center gap-5">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary text-white shadow-lg shadow-primary/25">
          <Icon className={`h-7 w-7 ${iconClassName}`} />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-primary/50">
            Back-office{section ? ` · ${section}` : ''}
          </p>
          <h2 className={`mt-0.5 truncate text-3xl font-bold text-zinc-900 ${titleClassName}`}>
            {title}
          </h2>
        </div>
      </div>
      {showBreadcrumb && (
        <BoBreadcrumb
          config={breadcrumbConfig}
          separator={breadcrumbSeparator}
          className="mt-2"
        />
      )}
    </div>
  );
};
